export const setPlan = (plan) =>
  localStorage.setItem("plan", plan || "UNILEVEL");
export const getPlan = () => localStorage.getItem("plan");
